module.exports = __webpack_public_path__ + "static/media/search-off.06e86d94.svg";